import { Component, EventEmitter, Output } from '@angular/core';

import { ModalService } from '@base/common/services/modal.service';

import { ModalComponent } from '@shared/modal/modal.component';

@Component({
    selector: 'checkout-error-modal-retry',
    templateUrl: './error-modal-retry.component.html',
    styleUrl: 'error-modal-retry.component.scss',
    imports: [ModalComponent],
    standalone: true,
})
export class ErrorModalRetryComponent extends ModalComponent {
    @Output() public retryEvent = new EventEmitter<boolean>();

    title: string = 'Oups !';
    tagEventImp: Record<string, string> = {
        nomClic: 'Affichage_modale_erreur_technique_avec_retentative_proposee',
        categorieClic: 'Modale_erreur_technique_avec_retentative_proposee',
    };
    tagEventCTA: Record<string, string> = {
        nomClic: 'Réessayez',
        categorieClic: 'Modale_erreur_technique_avec_retentative_proposee',
    };
    tagEventClose: Record<string, string> = {
        nomClic: 'Fermeture',
        categorieClic: 'Modale_erreur_technique_avec_retentative_proposee',
    };

    public modalRef: ModalService;

    public ngOnInit(): void {
        this.modalRef.afterClosed.subscribe(() => {
            this.onCloseHandler();
        });
    }

    private onCloseHandler(): void {
        this.retryEvent.emit();
    }
}
